var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowUpOnEstimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16699 1.50032V1.16699H15.5003V1.50032H5.16699Z",
    fill: "#374957",
    stroke: "#5A6385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16699 6.16635V5.83301H15.5003V6.16635H5.16699Z",
    fill: "#374957",
    stroke: "#5A6385"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16699 10.8333V10.5H15.5003V10.8333H5.16699Z",
    fill: "#374957",
    stroke: "#5A6385"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 1.33333C2.16667 1.79357 1.79357 2.16666 1.33333 2.16666C0.873095 2.16666 0.5 1.79357 0.5 1.33333C0.5 0.873096 0.873095 0.5 1.33333 0.5C1.79357 0.5 2.16667 0.873096 2.16667 1.33333Z",
    fill: "#374957",
    stroke: "#5A6385"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 7.33365C2.06971 7.33365 2.66667 6.7367 2.66667 6.00032C2.66667 5.26394 2.06971 4.66699 1.33333 4.66699C0.596954 4.66699 0 5.26394 0 6.00032C0 6.7367 0.596954 7.33365 1.33333 7.33365Z",
    fill: "#374957"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 10.6663C2.16667 11.1266 1.79357 11.4997 1.33333 11.4997C0.873095 11.4997 0.5 11.1266 0.5 10.6663C0.5 10.2061 0.873095 9.83301 1.33333 9.83301C1.79357 9.83301 2.16667 10.2061 2.16667 10.6663Z",
    fill: "#374957",
    stroke: "#5A6385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpOnEstimate);
export default __webpack_public_path__ + "static/media/follow-up-on-estimate.828b5146186ad28d78971a07c1e63c4c.svg";
export { ForwardRef as ReactComponent };